export const PATHS = {
  account: 'account',
  admin: {
    customers: 'customers',
    feedback: 'feedback',
    homepage: '/kh39sk39_dsf952',
    survey: 'survey',
  },
  any: '*',
  auth: 'auth',
  checkout: 'checkout',
  folders: 'folders',
  glossaries: 'glossaries',
  homepage: '/',
  pricing: 'pricing',
  project: 'project',
  spaces: 'spaces',
  voices: 'voices',
} as const;
